import { render, staticRenderFns } from "./MandatLightList.vue?vue&type=template&id=a4bd329e&"
import script from "./MandatLightList.vue?vue&type=script&lang=js&"
export * from "./MandatLightList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports